import { render, staticRenderFns } from "./ManageItinerary.vue?vue&type=template&id=90da8344&scoped=true"
import script from "./ManageItinerary.vue?vue&type=script&lang=js"
export * from "./ManageItinerary.vue?vue&type=script&lang=js"
import style0 from "./ManageItinerary.vue?vue&type=style&index=0&id=90da8344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da8344",
  null
  
)

export default component.exports